"use client";

import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Separator } from "@/components/ui/separator";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { Facebook, Mail, MapPin, Mountain, Phone, Twitter, Youtube } from "lucide-react";
function FooterMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div className="space-y-3">
        {[1, 2, 3, 4].map((_, i) => <div key={i} data-index={i} className="h-5 w-24 bg-primary-foreground/10 animate-pulse rounded-md" />)}
      </div>;
  }
  return <ul className="space-y-3">
      {menuItems.map((item, i) => <li key={item.id} data-index={i}>
          <Link to={item.href || "#"} className="text-primary-foreground/80 hover:text-primary-foreground transition-colors font-medium text-sm">
            {item.label}
          </Link>
        </li>)}
    </ul>;
}
export default function Footer() {
  const currentYear = new Date().getFullYear();
  const socialLinks = [{
    icon: Facebook,
    href: "https://www.facebook.com/share/1BBwaf2vkR/",
    label: "Facebook"
  }, {
    icon: Youtube,
    href: "https://www.youtube.com/@DurangoDogMassage",
    label: "YouTube"
  }];
  return <section id="footer" className="bg-primary text-primary-foreground pt-16 pb-8">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 lg:gap-8">
          
          <div className="space-y-6">
            <Link to="/" className="inline-block">
              <img src="/img/durango_dog_massage_logo_light.png" alt="Durango Dog Massage" className="h-7 w-auto" />
            </Link>
            <p className="text-primary-foreground/80 text-sm leading-relaxed max-w-xs">
              Dedicated to enhancing canine wellness through expert massage and bodywork rooted in evidence-based care, with a mountain-inspired calm environment.
            </p>
          </div>

          <div>
            <h3 className="font-default text-lg font-semibold mb-6">Quick Links</h3>
            <MenuProvider menu_id="43">
              <FooterMenuConsumer />
            </MenuProvider>
          </div>

          <div>
            <h3 className="font-default text-lg font-semibold mb-6">Contact</h3>
            <ul className="space-y-4">
              <li className="flex items-start gap-3 text-primary-foreground/80 text-sm">
                <MapPin className="h-5 w-5 shrink-0 text-primary-foreground/50" />
                <span>Durango, Colorado</span>
              </li>
              
              <li className="flex items-center gap-3 text-primary-foreground/80 text-sm">
                <Mail className="h-5 w-5 shrink-0 text-primary-foreground/50" />
                <Link to="mailto:durangodogmassage@gmail.com" className="hover:text-primary-foreground transition-colors">durangodogmassage@gmail.com</Link>
              </li>
              <li className="flex items-center gap-3 text-primary-foreground/80 text-sm">
                <Phone className="h-5 w-5 shrink-0 text-primary-foreground/50" />
                <Link to="tel:(970)279-3344" className="hover:text-primary-foreground transition-colors">(970) 279-3344</Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="font-default text-lg font-semibold mb-6">Follow Us</h3>
            <div className="flex flex-wrap gap-2">
              {socialLinks.map((social, i) => <Button key={i} data-index={i} variant="ghost" size="icon" className="hover:bg-primary-foreground/10 hover:text-primary-foreground text-primary-foreground/80 rounded-lg" asChild>
                  <Link to={social.href} aria-label={social.label}>
                    <social.icon className="h-5 w-5" />
                  </Link>
                </Button>)}
            </div>
          </div>
        </div>

        <Separator className="my-12 bg-primary-foreground/10" />

        <div className="flex flex-col md:flex-row items-center justify-between gap-4 text-sm text-primary-foreground/60">
          <p>© {currentYear} Durango Dog Massage. All rights reserved.</p>
          <div className="flex items-center justify-center" aria-hidden="true">
            <Mountain className="h-6 w-6 opacity-40" />
          </div>
        </div>
      </div>
    </section>;
}